export const LABELS_FICHA_TECNICA = {
    naoEncontrada: 'Ainda não há ficha técnica disponível.',
    falha: 'Não foi possível abrir a ficha técnica. Tente novamente mais tarde.',
};
